import React from 'react';

import CalendarIcon from '@/nikeone/components/sport-slider/components/calendar-icon/CalendarIcon';

function FakeSportsSlider({ superkurzy, todayOffer }: { superkurzy: boolean; todayOffer: boolean }) {
    return (
        <div className="filter flex flex-col c-default bg-white pt-2">
            <nav className="filter-swiper-overflow flex p-rel full-width">
                <div className="page-blur flex items-center flex-row">
                    {todayOffer ? (
                        <a className="filter-item bg-white p-rel flex-col flex items-center filter-item-mini px-2 pt-15">
                            <span>
                                <CalendarIcon fake />
                            </span>
                            <span className="filter-sport ellipsis c-default fs-10 py-5">Dnes</span>
                        </a>
                    ) : null}
                    {superkurzy ? <FakeSportsSliderItem sportName="superkurzy" /> : null}
                    <FakeSportsSliderItem sportName="tenis" />
                    <FakeSportsSliderItem sportName="futbal" />
                    <FakeSportsSliderItem sportName="basketbal" />
                </div>
            </nav>
        </div>
    );
}

function FakeSportsSliderItem({ sportName }: { sportName: string }) {
    return (
        <a className="filter-item bg-white p-rel flex-col flex items-center filter-item-mini px-2 pt-15">
            <span className={`sport-icon-small icon-${sportName}`} />
            <span className="filter-sport ellipsis c-default fs-10 py-5">{sportName}</span>
        </a>
    );
}

export default FakeSportsSlider;
